import {
    useContext,
    useEffect,
    useState,
} from 'react';

import {
    Col,
    Container,
    Form,
    Row,
} from 'react-bootstrap';

import { PreviousNextButtons } from '../controls/buttons';
import { RadioControl } from '../controls/radio';
import { TextControl } from '../controls/text';
import {
    HeightControl,
    WeightControl,
} from '../controls/units';
import {
    BrandingContext,
    GeoContext,
    InsuranceDataContext,
    LayoutContext,
    NotificationsContext,
    SessionContext,
} from '../libs/contexts';
import { scrollUp } from '../libs/ui';
import * as productQuestions from '../products/quickterm-questions';
import Navigation from './navigation';

export const General = () => {

    const { session, setSession } = useContext(SessionContext);
    const { layout, setLayout } = useContext(LayoutContext);
    const [mustRevalidate, setMustRevalidate] = useState(false);


    useEffect(() => {

        scrollUp();
        setLayout({ currentScreen: 'general', currentSection: 'personalinfo', screenReady: false });

    }, []);



    const onChange = (e) => {
        //onsole.info("Change in general", e);
        //todo check brackets here
    }

    const validateScreen = (options) => {

        setMustRevalidate(true);

    }


    return (
        <>
            <Form>
                <Container>
                    <Row className={layout.isDesktop ? "mt-4 mb-4" : ""}>
                        <Col>
                            <Navigation></Navigation>
                        </Col>
                    </Row>
                    <Row className={layout.isDesktop ? "mt-4 mb-4" : ""}>
                        <Col>
                            <h3>About you</h3>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className={layout.isDesktop ? "col-lg-12 col-xl-10" : "col-12 px-0"}>
                            <HeightControl mustRevalidate={mustRevalidate} />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className={layout.isDesktop ? "col-lg-12 col-xl-10" : "col-12 px-0"}>
                            <WeightControl mustRevalidate={mustRevalidate} />
                        </Col>
                    </Row>


                    {productQuestions.general.map((question, index) =>
                        <Row className="mt-2" key={index}>
                            <Col>
                                <RadioControl label={question.copy} choices={question.choices} type="horizontal" onChange={onChange} field={"A" + question.id} />
                            </Col>
                        </Row>
                    )}


                    <Row className="mt-4">
                        <Col>
                            {layout &&
                                <PreviousNextButtons enabled={layout.screenReady} callback={validateScreen} />
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>
        </>
    )

}

